
import { forwardRef, useImperativeHandle, useRef, useState } from "react";

const FieldDigit = forwardRef(({ index, onFill, onClear }, ref) => {
	const [digit, setDigit] = useState("");
	const inputRef = useRef(null);

	useImperativeHandle(ref, () => ({
		focus() {
			inputRef.current?.focus();
		},
		setDigitValue(value) {
			setDigit(value);
			handleDigitChange(value);
		},
	}));

	const handleDigitChange = (value) => {
		const v = value.replace(/\D/g, "");
		if (v.length === 0) {
			setDigit("");
			onClear(index);
		} else if (v.length >= 1) {
			const d = v.slice(-1);
			setDigit(d);
			onFill(index, d);
		}
	};

	return (
		<input
			ref={inputRef}
			type="text"
			maxLength={1}
			value={digit}
			onChange={(e) => handleDigitChange(e.target.value)}
			className="w-12 h-12 sm:w-14 sm:h-14 rounded-xl border border-[#E2E8F0] font-Vazir-700 text-[20px] text-darkBlue text-center focus:outline-none focus:border-darkBlue/40 focus:ring-2 focus:ring-darkBlue/10"
			placeholder="·"
			autoComplete="one-time-code"
			inputMode="numeric"
			aria-label={`رقم ${index}`}
		/>
	);
});

export default FieldDigit;
